import React from 'react';
import Extra from './Extra';

function ExtraContainer({prevStep, nextStep}) {
    return (
        <div>
            <Extra  prevStep={prevStep} nextStep={nextStep}/>
        </div>
    );
}

export default ExtraContainer;